import "handsontable/dist/handsontable.full.min.css";
import { CellProperties } from "handsontable/settings";
import { DropdownEditor } from "handsontable/editors";
import Core from "handsontable/core";
import { MatrixParameterValue } from "../interfaces/MatrixInputCell";

class CustomDropdownEditor extends DropdownEditor {
  select: HTMLSelectElement | undefined;

  currentValue: any;

  constructor(instance: Core, originalValue: MatrixParameterValue) {
    super(instance);
    this.currentValue = originalValue;
  }

  prepare(
    row: number,
    col: number,
    prop: string | number,
    td: HTMLTableCellElement,
    originalValue: MatrixParameterValue,
    cellProperties: CellProperties,
  ) {
    this.currentValue = originalValue;
    cellProperties.source = originalValue.parameterValue.parameter.values;
    super.prepare(row, col, prop, td, originalValue, cellProperties);
  }

  setValue(newValue?: any) {
    if (Array.isArray(newValue) || newValue === "[object Object]") {
      return;
    }

    if (this.currentValue && this.currentValue.parameterValue) {
      if (typeof newValue === "object") {
        this.currentValue = newValue;
        (this.TEXTAREA as HTMLInputElement).value = newValue.value;
      } else {
        // eslint-disable-next-line prefer-destructuring
        this.currentValue.parameterValue.value = newValue;
        (this.TEXTAREA as HTMLInputElement).value = newValue;
      }
    }
  }

  getValue() {
    return this.currentValue;
  }
}

export default CustomDropdownEditor;
